/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_integer.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Converts an input value to an integer value.\nIf the input parameter is of a date type, its value will be interpreted as milliseconds\nsince the Unix epoch, converted to integer.\nBoolean `true` will be converted to integer `1`, `false` to `0`.',
  examples: [
    'ROW long = [5013792, 2147483647, 501379200000]\n| EVAL int = TO_INTEGER(long)',
    'ROW str1 = "0x32", str2 = "31"\n| EVAL int1 = TO_INTEGER(str1, 16), int2 = TO_INTEGER(str2, 13)\n| KEEP str1, int1, str2, int2',
    'ROW str1 = "Kona"\n| EVAL int1 = TO_INTEGER(str1, 27), fail1 = TO_INTEGER(str1, 10)',
  ],
  params: {
    field: 'Input value. The input can be a single- or multi-valued column or an expression.',
    base: '(Optional) Radix or base used to convert the input value.When a base is specified the input type must be `keyword` or `text`.',
  },
};

export default docs;
